module.exports = __webpack_public_path__ + "assets/0e8ee15a6bb95d6b49b7f19e26dcb3bc.png";